import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {addPrComment, fetchPrComments} from "./portalRedirectCampaignsService";
import Loading from "../../components/loading";
import PrConfirmDialog from "./prConfirmDialog";

type Props = {
    row: any | null;
    onClose: () => void;
};

export default function PrCommentsModal({row, onClose}: Props) {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<any[]>([]);
    const [adding, setAdding] = React.useState(false);
    const [comment, setComment] = React.useState("");
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    const load = async (id: number) => {
        setLoading(true);
        setItems(await fetchPrComments(id));
        setLoading(false);
    };

    React.useEffect(() => {
        if (row?.portalRedirectId) {
            setAdding(false);
            setComment("");
            setConfirmOpen(false);
            setSaving(false);
            load(row.portalRedirectId);
        }
    }, [row?.portalRedirectId]);

    const save = async () => {
        setSaving(true);
        const ok = await addPrComment(row.portalRedirectId, comment);
        if (ok) {
            toast.success("Comment added");
            setComment("");
            setAdding(false);
            setConfirmOpen(false);
            load(row.portalRedirectId);
        }
        setSaving(false);
    };

    return (
        <>
        <Dialog open={!!row} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Comments: {row ? `${row.brokerName} > ${row.schoolName} - ${row.appId}` : ""}</DialogTitle>
            <DialogContent>
                <Box sx={{textAlign: "center", mb: 1}}>
                    <Button variant="contained" color="success" onClick={() => setAdding(!adding)}>Add Comment</Button>
                </Box>
                {adding && (
                    <>
                        <TextField fullWidth multiline minRows={6} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Comment"/>
                        <Box sx={{textAlign: "center", my: 1}}>
                            <Button variant="contained" onClick={() => setConfirmOpen(true)}>Add</Button>
                        </Box>
                    </>
                )}
                {loading ? <Loading/> : items.map((c) => (
                    <Box key={c.id} sx={{mb: 2, borderBottom: "1px solid #ddd", pb: 1}}>
                        <b>{c.name}</b> <span style={{color: "gray"}}>{c.date}</span>
                        <Box sx={{whiteSpace: "pre-line", mt: 1}}>{c.comments}</Box>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
            <PrConfirmDialog
                open={confirmOpen}
                message="Are you sure you want to add this comment?"
                loading={saving}
                onClose={() => { if (!saving) setConfirmOpen(false); }}
                onConfirm={save}
            />
        </>
    );
}
